<template>
  <div>
    <header style="padding-top: 10px;padding-left: 20px;">
      <div class="card-body" >
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 4px;margin-top: -7px;">
          <path d="M8.49946 17C9.51853 17 10.3961 16.3844 10.7811 15.5059H6.21777C6.60283 16.3844 7.48042 17 8.49946 17Z" fill="#3C434D"/>
          <path d="M13.6465 8.22979V7.13867C13.6465 4.82036 12.1055 2.85544 9.99418 2.21365V1.49414C9.99418 0.670272 9.32391 0 8.50004 0C7.67617 0 7.0059 0.670272 7.0059 1.49414V2.21365C4.89451 2.85544 3.35355 4.82033 3.35355 7.13867V8.22979C3.35355 10.2662 2.57733 12.1972 1.16789 13.667C1.02977 13.811 0.990953 14.0236 1.06925 14.2071C1.14754 14.3907 1.32783 14.5098 1.52738 14.5098H15.4727C15.6722 14.5098 15.8525 14.3907 15.9308 14.2071C16.0091 14.0236 15.9703 13.811 15.8322 13.667C14.4227 12.1972 13.6465 10.2662 13.6465 8.22979ZM8.99809 2.01636C8.83416 2.00055 8.66805 1.99219 8.50004 1.99219C8.33203 1.99219 8.16592 2.00055 8.00199 2.01636V1.49414C8.00199 1.21952 8.22542 0.996094 8.50004 0.996094C8.77466 0.996094 8.99809 1.21952 8.99809 1.49414V2.01636Z" fill="#3C434D"/>
          <path d="M14.9749 7.13844C14.9749 7.4135 15.1979 7.63649 15.4729 7.63649C15.748 7.63649 15.971 7.4135 15.971 7.13844C15.971 5.14294 15.1939 3.26686 13.7828 1.85583C13.5884 1.66136 13.273 1.66132 13.0785 1.85583C12.884 2.05033 12.884 2.36566 13.0785 2.56016C14.3014 3.78307 14.9749 5.40899 14.9749 7.13844Z" fill="#3C434D"/>
          <path d="M1.52734 7.63647C1.8024 7.63647 2.02539 7.41348 2.02539 7.13842C2.02539 5.409 2.69888 3.78308 3.92175 2.56018C4.11626 2.36567 4.11626 2.05034 3.92175 1.85584C3.72728 1.66133 3.41192 1.66133 3.21742 1.85584C1.80638 3.26687 1.0293 5.14291 1.0293 7.13842C1.0293 7.41348 1.25229 7.63647 1.52734 7.63647Z" fill="#3C434D"/>
          </svg> <span class="notification">Últimas notificações</span>

          <b-button-group size="sm" style="border-radius: 10px;height: 24px;position: absolute;right: 15px; top: 34px;">
            <b-button v-b-popover.hover="{ customClass: 'tooltip-class', content: 'Opções de Visibilidade'}"
                      v-if="bMore==false" variant="blank" style="border-radius: 10px 10px 10px 10px;"
                      @click="OpenFilterNotification"><i class="fa fa-tags" aria-hidden="true" style="font-size: 18px;"></i>

            </b-button>
            <b-button v-b-popover.hover="{ customClass: 'tooltip-class', content: 'Opções de Visibilidade'}"
                      v-if="bMore==true" variant="blank" style="border-radius: 10px 10px 10px 10px;color:#0d0d0d"
                    @click="FilterNotifications"><i class="fa fa-tags" aria-hidden="true" style="font-size: 18px;"></i>
            </b-button>
          </b-button-group>

          <b-card class="opcoes" style="position:absolute;z-index:1000;border-bottom-color: #B4B8C0;right: 4px; top: 67px;" variant="primary"
                  bg-variant="white" v-show="showVisibilityOptions"
          >
            <b-form-group label="Opções de visibilidade">
              <br>
              <b-form-checkbox-group
                stacked
                :options="visibleOptions"
                v-model="visibleOptionsSelected"
                @change="checkVisibleOptions"
              >
              </b-form-checkbox-group>

            </b-form-group>
          </b-card>
      </div>

      <div class="tabela-cognatis-nenhum" style="margin-left: -15px;"  v-if="notifications.length==0">
        Não há novas notificações
      </div>
    </header>




    <div style="overflow-x: hidden; overflow-x: auto; max-height: 600px;min-height: 108px">
      <table class="table" style="" v-if="notifications.length != 0" >
        <tbody>
          <tr v-for="item in FilterNotifications()" :key="item.nId">
            <th scope="row">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="#3FAD58" v-if='item.cType=="News"'/>
                <circle cx="4" cy="4" r="4" fill="#ffaa00" v-if='item.cType=="Warning"'/>
                <circle cx="4" cy="4" r="4" fill="#0c85d0" v-if='item.cType=="Info"'/>
                <circle cx="4" cy="4" r="4" fill="#a10f18" v-if='item.cType=="Error"'/>
                 <circle cx="4" cy="4" r="4" fill="#B4B8C0" v-if='item.cType!="Info" &&
                item.cType!="Error" && item.cType!="cType" && item.cType!="News"'/>
              </svg>
            </th>
            <td class="table-text"><strong>{{item.cTitle}}:</strong> {{item.cShortMessage}}</td>
            <td>{{ formatDate(item.dtCreated)}}</td>
            <td><a href="#" @click="MarkAsRead(item.nId)"><i class="material-icons"> close </i></a></td>
            <td style="display:none"><b-button-group v-for=" (action, key) in item.jbAction" :key="key">
                    <b-button class="mr-1" size="sm" variant="info" @click.stop.prevent="CallActionMethod(action,item)">
                      {{action.alias}}
                    </b-button>
                  </b-button-group>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <footer>
      <b-btn variant="link" size="sm" style="width: 100%" @click="MarkAllAsRead()" v-if="notifications.length != 0">
        Marcar todas como lida
      </b-btn>
      <div class="notif-anterior" style="border-top: 1px solid #E8E8E8;padding: 20px;" ><a href="#">Ver notificações anteriores</a></div>
    </footer>
    <b-modal :ref='"my-modal"'
             :id='"my-modalId"'
             title="Mensagem"
             v-model="showModalLongMessage"
             size="lg"
             scrollable
             hide-backdrop
             no-close-on-backdrop

    >
      {{sLongMessage }}
    </b-modal>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {loadProgressBar} from 'axios-progress-bar'
  import {DataManager, Query} from '@syncfusion/ej2-data';
  import Services from '../http/request'
  import messenger from '../messenger/messenger'
  import io from 'socket.io-client';
  import moment from 'moment';

  export default {
    name: "NotificationManager",
    data: () => ({
      showModalLongMessage: false,
      bMore: false,
      showVisibilityOptions: false,
      notifications: [],
      visibleOptionsSelected: ['Info', 'News'],
      visibleOptions: [
        {text: 'Informações', value: 'Info'},
        {text: 'Novidades', value: 'News'},
        {text: 'Erros', value: 'Error'},
        {text: 'Avisos', value: 'Warn'},
        {text: 'Todas', value: 'Other'}
      ],
      sLongMessage: ""
    }),
    methods: {
      checkVisibleOptions(e){
        let bOthers=false
        for (let i = 0; i < e.length; i++) {
          if (e[i] == 'Other') bOthers = true
        }
        if(bOthers==true)
         this.visibleOptionsSelected =  ['Info', 'News','Error','Warn','Other']
      },
      OpenFilterNotification() {
        this.showVisibilityOptions = !this.showVisibilityOptions
      },
      CheckMessages() {
        //console.log("Requisitando notificações...")
        let request = new Services({tag: 'das'});
        let environmentId = Vue.prototype.$foundation.getEnvironmentId();
        let userId = Vue.prototype.$foundation.getTokenClaims()["UserId"];
        let baseUri = `/api/0.1-a/Messenger/GetNewMessages/${environmentId}/${userId}`;
        request.get(baseUri, {}, (response) => {
          this.notifications = response.data;
          this.$bus.$emit('updateMessages', this.notifications);
          //console.log(this.notifications)
        }, (error) => {
          console.log(error)
        });
      },
      MarkAsRead(id) {
        let request = new Services({tag: 'das'});
        let baseUri = `/api/0.1-a/Messenger/MarkAsRead/${id}`;
        request.get(baseUri, {}, (response) => {
          this.CheckMessages();
        }, (error) => {
          console.log(error)
        });
      },
      MarkAllAsRead() {
        let _this = this
        this.notifications.forEach(function (item) {
          _this.MarkAsRead(item.nId)
        })
        messenger.info({position: 'top-end', title: 'Notificações Lidas !'});
      },
      CallActionMethod(action, item) {
        switch (action.method) {
          case "NewItemOnToc":
              this.showVisibilityOptions=false;
              this.$router.push('/home');
              this.$bus.$emit('closeUploadStatistics');
              this.$bus.$emit('openLayerManager');
              this.$bus.$emit('UpdateToc');
              break;
          case "ShowProperties":
              this.showVisibilityOptions=false;
              const args = action.arguments || {};
              //args.layer = args.gdIdEvent;
              //this.$bus.$emit('ShowAndHideToc');
              this.$bus.$emit('closeTabela');
              this.$bus.$emit('showUploadStatistics', args, args.layerName);
              break;
          case "ShowPurchase":
              this.showVisibilityOptions=false;
              this.$bus.$emit('onShowPurchase', action.arguments || {});
              break;
          default:
            this.showVisibilityOptions=false
            this.sLongMessage = item.longMessage
            this.showModalLongMessage = true
        }
      },
      addNotification(message) {
        this.notifications.push(message)
        messenger.info({position: 'top-end', title: message.message});
      },
      FilterNotifications() {
        var filterList = []
        try {
          let bFilterWarning = false
          let bFilterError = false
          let bFilterInfo = false
          let bFilterNews = false
          let bOtherFilter = false

          for (let i = 0; i < this.visibleOptionsSelected.length; i++) {
            if (this.visibleOptionsSelected[i] == 'Info') bFilterInfo = true
            if (this.visibleOptionsSelected[i] == 'News') bFilterNews = true
            if (this.visibleOptionsSelected[i] == 'Warn') bFilterWarning = true
            if (this.visibleOptionsSelected[i] == 'Error') bFilterError = true

            if (this.visibleOptionsSelected[i] == 'Other') bOtherFilter = true
          }

          if (bOtherFilter == true) {
            return (this.notifications)
          }

          if (bFilterInfo == true) {
            let lsInfo = this.notifications.filter(item => {
              if (item.cType == undefined) item.cType = ""
              return item.cType.toLowerCase().indexOf("info") > -1
            })
            filterList = filterList.concat(lsInfo)
          }

          if (bFilterNews == true) {
            let lsNews = this.notifications.filter(item => {
              if (item.cType == undefined) item.cType = ""
              return item.cType.toLowerCase().indexOf("news") > -1
            })
            filterList = filterList.concat(lsNews)
          }
          if (bFilterWarning == true) {
            filterList = filterList.concat(this.notifications.filter(item => {
              if (item.cType == undefined) item.cType = ""
              return item.cType.toLowerCase().indexOf("warning") > -1
            }))
          }

          if (bFilterError == true) {
            filterList = filterList.concat(this.notifications.filter(item => {
              if (item.cType == undefined) item.cType = ""
              return item.cType.toLowerCase().indexOf("error") > -1
            }))
          }
          return filterList.sort(function (a, b) {
            return b.nId - a.nId;
          });
        } catch (e) {
          console.log('Erro na filtragem')
          console.log(e)
          return this.notifications
        }

      },
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY HH:mm');
      },
      handleEvents: function () {
        this.$bus.$on('addNotification', (message) => {
          this.addNotification(message)
        })
      },
      handleMessages: function () {
        try {
          let user = Vue.prototype.$foundation.getTokenClaims()["cUser"];
          let domain = Vue.prototype.$foundation.getTokenClaims()["cClient"];
          let request = new Services({tag: 'messenger'});
          let endPoint = `${request.getServiceEndPoint({})}`;
          let socket = io(endPoint);
          const self = this;

          //Listener de mensagens (front-end, back-end e outros usuários)
          socket.on('onNotify', function (data) {
            console.log("Notificado")
            console.log(data)
            self.CheckMessages()
          });

          //Listener de mensagens para login privado
          socket.on('onLogin', function (input) {
            if (!input) return;
            if (input.hasOwnProperty("token")) {
              Vue.prototype.$foundation.setMessengerId(input.token);
              //console.log(input.client)
            }
            if (input.hasOwnProperty("message")) {
              self.addNotification({
                type: "info",
                title: "???",
                message: input.message
              })
            }
          });

          //Listener de mensagens para login do domínio/sala
          socket.on('onConnected', function (data) {
            //console.log(JSON.stringify(data));
          });

          //Listener de mensagens para logoff do domínio/sala
          socket.on('onDisconnected', function (data) {
            //console.log(JSON.stringify(data));
          });

          //Listener de mensagens para alterações na sala
          socket.on('onRoomChanged', function (data) {
            //console.log(JSON.stringify(data));
          });

          socket.emit("join", user, domain);
        } catch (e) {
          console.log(e);
        }
      },
    },
    created() {
      this.handleEvents();
      console.log('Notificações Desligadas Temporariamente')
      //this.handleMessages();
    },
    mounted() {
      this.CheckMessages();
    }
  }
</script>

<style scoped>

</style>
